import { Flex, Text, useBreakpointValue } from '@chakra-ui/react';

import { Pagination as PaginationComponent } from '@/components/Pagination';
import { usePortalEventStore } from '@store/portal-event';

interface PaginationProps {
  pagination: {
    currentPage: number;
    total: number;
    from: number;
    to: number;
  };
}

export function Pagination({ pagination }: PaginationProps) {
  const { currentPage, changeCurrentPage } = usePortalEventStore(
    (state) => state,
  );
  const isMobile = useBreakpointValue(
    {
      base: true,
      md: false,
    },
    {
      ssr: false,
    },
  );

  if (pagination.total > 10) {
    return (
      <Flex
        mt="0.75rem"
        px="1.375rem"
        bg="white"
        rounded="0.5rem"
        py="1.25rem"
        justify="space-between"
      >
        {!isMobile && (
          <Text>
            Visualizando {pagination.from}-{pagination.to} de {pagination.total}{' '}
            eventos.
          </Text>
        )}

        <PaginationComponent
          totalCountOfRegisters={pagination.total}
          currentPage={currentPage}
          setCurrentPage={changeCurrentPage}
          registerPerPage={10}
        />
      </Flex>
    );
  }
}
